import { render, staticRenderFns } from "./DadosObservacao.vue?vue&type=template&id=3b78c847"
import script from "./DadosObservacao.vue?vue&type=script&lang=js"
export * from "./DadosObservacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports